import React from "react";
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  IconButton,
  Typography,
} from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

const LogicSlotEditor = ({ node, onChange, onDelete, questions }) => {
  const handleNameChange = (e) => {
    onChange({
      ...node,
      slotId: e.target.value,
    });
  };

  const handleQuestionChange = (e) => {
    onChange({
      ...node,
      questionId: e.target.value || null,
    });
  };

  const selectedQuestion = questions.find((q) => q.id === node.questionId);

  return (
    <Box sx={{ mb: 1 }}>
      <Stack direction="row" spacing={1} alignItems="flex-end">
        <TextField
          label="Slot name"
          size="small"
          value={node.slotId || ""}
          onChange={handleNameChange}
          sx={{ flex: 1 }}
          placeholder="e.g. Gender, Age, Birth gender"
        />

        <FormControl size="small" sx={{ flex: 1 }}>
          <InputLabel>Question</InputLabel>
          <Select
            label="Question"
            value={node.questionId || ""}
            onChange={handleQuestionChange}
          >
            <MenuItem value="">
              <em>Select question</em>
            </MenuItem>
            {questions.map((q) => (
              <MenuItem key={q.id} value={q.id}>
                {q.title?.English ?? q.title}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {onDelete && (
          <IconButton
            size="small"
            onClick={onDelete}
            aria-label="Delete slot"
            sx={{ mb: 0.5 }}
          >
            <DeleteOutlineIcon fontSize="small" />
          </IconButton>
        )}
      </Stack>

      {selectedQuestion && (
        <Typography variant="caption" color="text.secondary">
          {selectedQuestion.title?.English ?? selectedQuestion.title}
        </Typography>
      )}
    </Box>
  );
};

export default LogicSlotEditor;
